export const updateState = (state = {}, update = {}) => {
  return {
    ...state,
    ...update,
  };
};

export const resetState = () => {
  return {};
};
